export const BPOSTInvalidAddressMessageId = "bpost-invalid-address";
